import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { withStyles } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';
import Box from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/Box';
import Alert from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/Alert';
import Typography from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/Typography';

const styles = theme => ({
  root: {
    margin: theme.spacing(2, 0),
  },
});

const WarningMessage = ({
  className,
  classes,
  message,
  visible,
  test,
}) => {
  if (!visible) return null;
  return (
    <Box
      className={classNames(classes.root, className)}
      test={test}
    >
      <Alert
        severity="warning"
      >
        <Typography>
          {message}
        </Typography>
      </Alert>
    </Box>
  );
};

WarningMessage.defaultProps = {
  className: '',
  visible: false,
  test: 'alert-message',
};

WarningMessage.propTypes = {
  className: PropTypes.string,
  classes: PropTypes.object.isRequired,
  message: PropTypes.string.isRequired,
  visible: PropTypes.bool,
  test: PropTypes.string,
};

export default withStyles(styles)(WarningMessage);
